import { useAuth } from "@/contexts/AuthContext";
import { UserAuthState, UserProfile } from "@/types";
import { TAppUser, TAppUserState } from "@types";

/**
 * Compatibility wrapper over the AuthContext. With httpOnly-cookie auth there
 * is no JS-readable token; `token` is exposed as a truthy placeholder when the
 * user is authenticated so existing consumers (`user && token`, `if (!token)`)
 * keep working unchanged. Prefer `useAuth()` / `is_logged_in` in new code.
 */
function useAuthToken() {
  const {
    user,
    is_logged_in,
    status,
    logout,
    updateUser: contextUpdateUser,
    updatePhotoURL,
  } = useAuth();

  const token = is_logged_in ? "authenticated" : null;
  const isLoading = status === "idle" || status === "loading";

  const updateUser = (userData: TAppUserState) => {
    const state: UserAuthState = {
      token: userData.token,
      user: userData.user as unknown as UserProfile,
      loginTime: userData.loginTime,
    };
    contextUpdateUser(state);
  };

  return {
    token,
    user: user as TAppUser | null,
    isLoading,
    is_logged_in,
    updateUser,
    logout,
    updatePhotoURL,
  };
}

export default useAuthToken;
